{
  "Accessibility Menu": "Menu di accessibilità",
  "Reset settings": "Ripristina impostazioni",
  "Close": "Chiudi",
  "Content Adjustments": "Regolazioni del contenuto",
  "Adjust Font Size": "Regola la dimensione del carattere",
  "Highlight Title": "Evidenzia il titolo",
  "Highlight Links": "Evidenzia i collegamenti",
  "Readable Font": "Carattere leggibile",
  "Color Adjustments": "Regolazioni del colore",
  "Dark Contrast": "Contrasto scuro",
  "Light Contrast": "Contrasto chiaro",
  "High Contrast": "Alto contrasto",
  "High Saturation": "Alta saturazione",
  "Low Saturation": "Bassa saturazione",
  "Monochrome": "Monocromatico",
  "Contrast": "Contrasto",
  "Invert Colors": "Inverti colori",
  "Tools": "Strumenti",
  "Reading Guide": "Guida alla lettura",
  "Stop Animations": "Arresta le animazioni",
  "Big Cursor": "Cursore grande",
  "Increase Font Size": "Aumenta la dimensione del carattere",
  "Decrease Font Size": "Diminuisci la dimensione del carattere",
  "Letter Spacing": "Spaziatura delle lettere",
  "Line Height": "Altezza della linea",
  "Font Weight": "Peso del carattere",
  "Dyslexia Font": "Carattere per dislessia",
  "Language": "Lingua",
  "Open Accessibility Menu": "Apri il menu di accessibilità",
  "Widget Settings": "Impostazioni widget",
  "Widget Position": "Posizione widget",
  "Top Left": "In alto a sinistra",
  "Top Center": "In alto al centro",
  "Top Right": "In alto a destra",
  "Center Left": "Centro sinistra",
  "Center Right": "Centro destra",
  "Bottom Left": "In basso a sinistra",
  "Bottom Center": "In basso al centro",
  "Bottom Right": "In basso a destra",
  "Screen Reader": "Lettore schermo",
  "Voice Navigation": "Navigazione vocale",
  "Custom Color": "Colore personalizzato",
  "Change the site's colors": "Modifica i colori del sito",
  "Backgrounds": "Sfondi",
  "Headings": "Intestazioni",
  "Contents": "Contenuti",
  "Reset colors": "Reimposta colori",
  "Image Desaturation": "Desaturazione immagine",
  "Search languages": "Cerca lingue",
  "No languages found": "Nessuna lingua trovata",
  "Accessibility Profiles": "Profili di accessibilità",
  "Motor Impaired": "Disabilità motoria",
  "Big cursor, voice navigation, and no animations.": "Cursore grande, navigazione vocale e nessuna animazione.",
  "Blind": "Non vedente",
  "Screen reader helpers with higher contrast.": "Assistenti per screen reader con contrasto maggiore.",
  "Color Blind": "Daltonismo",
  "High contrast palette with desaturated media.": "Palette ad alto contrasto con media desaturati.",
  "Dyslexia": "Dislessia",
  "Friendly font, extra spacing, stronger weight.": "Carattere leggibile, spaziatura extra e peso più marcato.",
  "Low vision": "Ipovisione",
  "Dark contrast and 130% magnification.": "Contrasto scuro e ingrandimento del 130 %.",
  "Cognitive & Learning": "Cognitivo e apprendimento",
  "Highlights key sections and enables voice help.": "Evidenzia le sezioni chiave e abilita l'assistenza vocale.",
  "Seizure & Epileptic": "Convulsioni ed epilessia",
  "Stops animations and desaturates imagery.": "Blocca le animazioni e desatura le immagini.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Guida di lettura, link evidenziati e palette più calma.",
  "Widget Size": "Dimensioni widget",
  "Default": "Predefinito",
  "Medium": "Medio",
  "Small": "Piccolo",
  "Color Blindness": "Daltonismo",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Acromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simula e supporta gli utenti con deficit della visione dei colori."
}
